/**
 * @fileoverview Features section — 3×2 grid of headline capabilities.
 * Each card uses the same primary-tinted bottom-to-top wash the dashboard
 * stat cards do, so the cards re-tint automatically when the visitor
 * swaps the accent palette in the header drawer.
 *
 * Extracted verbatim out of the original Landing/index.tsx.
 */
import { Badge } from '@/components/ui/badge'
import { Card, CardContent } from '@/components/ui/card'
import { FEATURES } from '../constants'

export function FeaturesSection() {
  return (
    <section id="features" className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <Badge variant="outline" className="mb-3">Platform</Badge>
        <h2 className="text-balance text-3xl font-bold tracking-tight sm:text-4xl">
          Everything you need to run cricket
        </h2>
        <p className="mt-3 text-muted-foreground">
          One backend, one mobile app, one admin web. Designed so the people on
          the field never need to context-switch between tools.
        </p>
      </div>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map((f) => {
          const Icon = f.icon
          return (
            <Card
              key={f.title}
              className="group relative overflow-hidden rounded-2xl border border-primary/10 bg-white dark:bg-card shadow-sm transition-all hover:border-primary/40 hover:shadow-md"
            >
              {/* Same bottom-to-top palette wash recipe the dashboard
                  `GradientStatCard` uses. `bg-primary/N` re-tints with
                  the active accent automatically. */}
              <div
                aria-hidden
                className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary/8 via-primary/2 to-transparent"
              />
              <CardContent className="relative p-6">
                <div className="mb-4 inline-flex rounded-lg bg-primary/10 p-2.5 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="text-base font-semibold">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                  {f.description}
                </p>
              </CardContent>
            </Card>
          )
        })}
      </div>
    </section>
  )
}
